// extracted by mini-css-extract-plugin
export var container = "_20-0";